import { FC, ReactNode, createContext, useCallback, useContext, useMemo, useState } from 'react'

export interface ConfigurableContainer {
    id: string
    name: string
}

interface ActionsContextValue {
    set: (container: ConfigurableContainer) => void
    unset: () => void
}

const Context = createContext<ConfigurableContainer | null>(null)

const ActionsContext = createContext<ActionsContextValue>({
    set: () => {},
    unset: () => {},
})

interface ConfigurableContainerProviderProps {
    children: ReactNode
}

const ConfigurableContainerProvider: FC<ConfigurableContainerProviderProps> = ({ children }) => {
    const [container, setContainer] = useState<ConfigurableContainer | null>(null)

    const unset = useCallback(() => setContainer(null), [])

    const actions = useMemo(() => ({ set: setContainer, unset }), [unset])

    return (
        <Context.Provider value={container}>
            <ActionsContext.Provider value={actions}>{children}</ActionsContext.Provider>
        </Context.Provider>
    )
}

export default ConfigurableContainerProvider

export const useConfigurableContainer = (): ConfigurableContainer | null => useContext(Context)

export const useConfigurableContainerActions = (): ActionsContextValue => useContext(ActionsContext)
